export enum BunkeringDateStatusEnum {
    noBunkering = 1,
    unregisteredBunkering = 2,
    registeredBunkering = 3,
    approvedOrInUseBunkering = 4,
    spentBunkering = 5,
    rejectedBunkering = 6,
    debunkered = 7,
}
